import React, { useState, useEffect, forwardRef } from 'react';
import classnames from 'classnames';
import { Input } from 'antd';

export default forwardRef(function PaymentLink({ t, setQueryParams, queryParams }, ref) {
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState();

  const isValidURL = url => {
    const pattern =
      /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    return pattern.test(url);
  };

  const handleValidate = value => {
    if (!value) {
      setError(true);
      setErrorMsg(t('properties.listing_management.payment_method.input_error.empty'));
      setQueryParams({
        ...queryParams,
        isValid: false,
        data: {
          paymentLink: null,
        },
      });
      return false;
    }

    if (!isValidURL(value)) {
      setError(true);
      setErrorMsg(t('properties.listing_management.payment_method.input_error.format'));
      setQueryParams({
        ...queryParams,
        isValid: false,
        data: {
          paymentLink: null,
        },
      });
      return false;
    }

    setError(false);
    setQueryParams({
      ...queryParams,
      data: {
        paymentLink: value,
      },
    });
    return true;
  };

  const handleOnChange = event => {
    const inputValue = event.target.value;
    handleValidate(inputValue);
  };

  useEffect(() => {
    ref.current = handleValidate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <p className="method-desc" style={{ marginBottom: 8 }}>
        {t('properties.listing_management.payment_method.payment_link.desc1')}
      </p>
      <p className="method-desc">
        {t('properties.listing_management.payment_method.payment_link.desc2')}
      </p>
      <div className="method-input-wrapper">
        <div className="label">
          {t('properties.listing_management.payment_method.payment_link.title')}
        </div>
        <div className={classnames('input-container', error && 'input-error-container')}>
          <Input
            onChange={handleOnChange}
            placeholder="Please input payment link"
            defaultValue={queryParams?.data?.paymentLink}
          />
          {error && <span className="input-error">{errorMsg}</span>}
        </div>
      </div>
    </div>
  );
});
